import createApiService from "./create";
import Router from "@/components/common/Router";
const logout = () => {
  localStorage.setItem('auth-user', null);
  localStorage.setItem('auth-token', null);
  localStorage.setItem('user-data', null);
  Router.push('/login');
}
const api = createApiService({});
export const privateApi = createApiService({
  getDefaultHeaders() {
    const token = localStorage.getItem("auth-token");
    return {
      Authorization: `Token ${token}`,
    };
  },
  catchMissingAuth(err) {
    console.log('missing auth');
    logout();
  }
});

export default api;
